import { render, staticRenderFns } from "./OrderKaufschutzCreate.vue?vue&type=template&id=46e7697a&scoped=true&"
import script from "./OrderKaufschutzCreate.vue?vue&type=script&lang=js&"
export * from "./OrderKaufschutzCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrderKaufschutzCreate.vue?vue&type=style&index=0&id=46e7697a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7697a",
  null
  
)

export default component.exports